import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import GitHubLogo from '../github-logo';
import SectionOne from './templates/section-one'
import SectionTwo from './templates/section-two'
import { ReactiveBase, CategorySearch, SingleRange, ResultCard, DataSearch } from '@appbaseio/reactivesearch';
import ConvoBot from '../convo-bot'



class ReactiveSearch extends Component {
	constructor() {
	  super();
  
	  this.state = {
  
	  };
	}

	componentDidMount(){
		window.scrollTo(0, 0)

	}
	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
		  window.scrollTo(0, 0)
		}
	  }

	render () {

		return(
			<div>
			<div class="page__header">
<div class="hero__overlay hero__overlay--gradient"></div>
<div class="hero__mask"></div>
<div class="page__header__inner">
	<div class="container">
		<div class="page__header__content" style={{paddingBottom:'5px', paddingTop:'0px'}}>
			<div class="page__header__content__inner" id="navConverter">
				<h1 class="page__header__title" style={{marginBottom:'15px'}}>Join the Coliving List</h1>
				<p class="page__header__text">Answer some questions and get access to the Coliving List, where you can meet other makers looking for coliving opportunities. </p>
			</div>
		</div>
	</div>
</div>
</div>
<div style={{position:'relative', marginTop:'20px'}}>
<div style={{width:'700px', maxWidth:'100%', margin:'0 auto',zIndex:1}}>
<ConvoBot/>

</div>
</div>
				<div className="hero__sub">
																									

				</div>
				
				</div>
		);
	
	  }
}


export default ReactiveSearch;



// WEBPACK FOOTER //
// ./src/views/components/reactive-search/reactive-search.js